import { isDefined } from "@clipboard-health/util-ts";

import { useInHomeVisibility } from "../lib/useInHomeVisibility";
import { InHomeBookedVisitsList } from "./List";

export function InHomeBookedVisitsContainer() {
  const { isInHomeEnabled, bookedVisits } = useInHomeVisibility();
  if (!isInHomeEnabled || (isDefined(bookedVisits) && bookedVisits === 0)) {
    return null;
  }

  return <InHomeBookedVisitsList />;
}
